import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  OauthAEMConfig,
  SelectDevice,
  SelectDevicePayload
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SelectDeviceService {
  selectDeviceHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.selectDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  selectDevice = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    deviceRef: string
  ): Observable<SelectDevice> => {
    const getSelectDeviceUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const selectDeviceUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSelectDeviceUrl
      }
    ];

    const payload: SelectDevicePayload = {
      deviceRef: {
        id: deviceRef
      }
    };

    return new ApiBuilder<SelectDevicePayload, SelectDevice>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(selectDeviceUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.selectDeviceHeader)
      .errorHandler(this._errorHandler)
      .library('SELECT_DEVICE_SERVICE')
      .withCredentials(true)
      .create();
  };
}
